module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.showGrid) ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('tipo de documento')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3 col-lg-2",
    attrs: {
      "for": "tipo de documento"
    }
  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('div', {
    attrs: {
      "ng-if": "!$ctrl.flagNovoDocumento",
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalStateForm"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documento.documentType),
      expression: "documento.documentType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "name": "tipo de documento",
      "id": "tipo de documento"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.documento, "documentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.documentos), function(documento) {
    return _c('option', {
      domProps: {
        "value": documento
      }
    }, [_vm._v(_vm._s(documento.type))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('arquivo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3 col-lg-2",
    attrs: {
      "for": "file"
    }
  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        size: _vm.tamanhoPermitido,
        mimes: _vm.tiposPermitidos
      }),
      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
    }],
    ref: "file",
    attrs: {
      "type": "file",
      "name": "arquivo",
      "id": "file"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })]), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3 col-lg-2",
    attrs: {
      "for": "expirationDate"
    }
  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    attrs: {
      "ng-if": "!$ctrl.flagNovoDocumento",
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalStateForm"
    }
  }, [_c('datepicker', {
    attrs: {
      "name": "expirationDate",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.documento.expirationDate),
      callback: function($$v) {
        _vm.$set(_vm.documento, "expirationDate", $$v)
      },
      expression: "documento.expirationDate"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-9 col-lg-10 col-md-offset-3 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button",
      "id": "cmpt-upload-add"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button",
      "id": "cmpt-upload-cancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showGrid) ? _c('div', [_c('input', {
    attrs: {
      "type": "hidden",
      "id": "myField",
      "name": "myField",
      "value": ""
    }
  }), _vm._v(" "), (!_vm.disable) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "uib-tooltip": "Adiciona um documento",
      "type": "button"
    },
    on: {
      "click": _vm.onNew
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo documento")])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.documentTypes), function(pendente) {
    return (!_vm.existeDocumento(pendente)) ? _c('tr', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('td', [_vm._v(_vm._s(pendente.type))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [(!_vm.disable) ? _c('button', {
      staticClass: "btn btn-primary btn-sm btn-flat btn-block",
      staticStyle: {
        "max-width": "135px",
        "text-align": "center"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.onAddFile(pendente)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Adicionar arquivo")]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
    return _c('tr', {
      staticStyle: {
        "text-align": "center"
      }
    }, [(_vm._.has(documento.documentType, 'type')) ? _c('td', [_vm._v(_vm._s(documento.documentType.type))]) : _c('td'), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "ng-binding",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.onDownload(documento)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v(" " + _vm._s(documento.fileName))])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.createdAt, 'DD/MM/YYYY')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.expirationDate, 'DD/MM/YYYY')))]), _vm._v(" "), _c('td', [(!_vm.disable) ? _c('button', {
      staticClass: "btn btn-primary btn-sm btn-flat",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.onEdit(documento)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (!_vm.disable) ? _c('button', {
      staticClass: "btn btn-danger btn-sm btn-flat",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.onDelete(indexDocumento)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")]) : _vm._e()])])
  })], 2)])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")]), _vm._v(" "), _c('td', [_vm._v("Vigência")]), _vm._v(" "), _c('td', [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Pendente")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37b63fb5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/uploadDocumentos.vue
// module id = 1906
// module chunks = 1